import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-lg-8 mx-auto" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "radio-health-options my-4" }
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "value", "checked", "disabled", "onChange"]
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "fw-bold" }

import { ref, computed, watch, onMounted } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import HelpText from "@/guiide/ts/helpText";
import Help from "@/guiide/components/common/Help.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import HealthState from "../ts/healthState";
import { useStore } from "vuex";
import { app } from "../ts/app";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";
import { getAgeAtRetirement } from "../ts/utilities";


export default /*@__PURE__*/_defineComponent({
  __name: 'Life',
  setup(__props) {

const store = useStore();
const selectedHealthState = ref(store.state.retiree?.health);
const disableInputs = ref(false);
const nextLink = ref("");

onMounted(async () => {
  const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Life);
  nextLink.value = nextWorkflowStep.resource;
});

function createHealthOption(healthState: HealthState, text: string) {
  return { healthState, text };
}

const healthOptions = [
  createHealthOption(HealthState.PreferNotToSay, "I'd rather not say"),
  createHealthOption(HealthState.Perfect, "I am in perfect health"),
  createHealthOption(HealthState.Minor, "I have some minor health issues"),
  createHealthOption(
    HealthState.Moderate,
    "I have some moderate health issues"
  ),
  createHealthOption(HealthState.Major, "I have some major health issues"),
];

const displayLifeExpectancyText = computed<boolean>(
  () =>
    store.state.retiree?.lifeExpectancy != null &&
    store.state.retiree?.lifeExpectancy != 0
);
const lifeExpectancy = computed<number>(
  () => store.state.retiree?.lifeExpectancy ?? 0
);
const ageAtDeath = computed<number>(() => {
  const age = getAgeAtRetirement();
  return age == null ? 0 : age + lifeExpectancy.value;
});

watch(
  () => store.state.retiree,
  (newRetireeValue) => {
    selectedHealthState.value = newRetireeValue?.health;
  }
);

function getHelpTitle(healthState: HealthState) {
  switch (healthState) {
    case HealthState.PreferNotToSay:
      return "Rather not say";
    case HealthState.Perfect:
      return "Perfect health";
    case HealthState.Minor:
      return "Minor health issues";
    case HealthState.Moderate:
      return "Moderate health issues";
    case HealthState.Major:
      return "Major health issues";
  }
}

function getHelpText(healthState: HealthState) {
  switch (healthState) {
    case HealthState.PreferNotToSay:
      return HelpText.healthStateRatherNotSay();
    case HealthState.Perfect:
      return HelpText.healthStatePerfect();
    case HealthState.Minor:
      return HelpText.healthStateMinor();
    case HealthState.Moderate:
      return HelpText.healthStateModerate();
    case HealthState.Major:
      return HelpText.healthStateMajor();
  }
}

async function changeHealthStatus(healthState: HealthState) {
  disableInputs.value = true;
  selectedHealthState.value = healthState;
  await app.updateHealthState(healthState);
  disableInputs.value = false;
}

async function onNextClicked() {
  if (selectedHealthState.value == null) {
    return;
  }

  await workflow.goToNextWorkflowStep();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(WorkflowNavigation, { workflowStage: "Life" }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-10 mx-auto" }, [
        _createElementVNode("h2", { class: "skin-page-heading" }, " Have you thought about how long you'll need your retirement savings to last? "),
        _createElementVNode("p", null, " None of us know exactly how long we'll live in retirement, but getting a better idea can help you plan with more confidence. Many people are surprised to learn just how long that might be! ")
      ], -1))
    ]),
    _createVNode(SubSection, {
      title: "Your health",
      "show-help": false
    }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("p", {
          id: "healthQuestion",
          class: "mt-2"
        }, " If you are happy to answer the health question below, we will adjust your life expectancy to allow for your health. If not, we will use average life expectancy. ", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(healthOptions, (healthOption, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "my-3"
            }, [
              _createElementVNode("label", {
                for: `radio-health-${index}`
              }, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  id: `radio-health-${index}`,
                  value: healthOption.healthState,
                  checked: healthOption.healthState == selectedHealthState.value,
                  name: "healthStatus",
                  disabled: disableInputs.value,
                  onChange: ($event: any) => (changeHealthStatus(healthOption.healthState))
                }, null, 40, _hoisted_5),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "custom-radio" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(healthOption.text) + " ", 1),
                _createVNode(Help, {
                  title: getHelpTitle(healthOption.healthState),
                  text: getHelpText(healthOption.healthState),
                  isWide: true
                }, null, 8, ["title", "text"])
              ], 8, _hoisted_4)
            ])
          }), 64))
        ]),
        (displayLifeExpectancyText.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", _hoisted_6, [
                _cache[2] || (_cache[2] = _createTextVNode(" Based on your answer above, you may be expected to live on average to around ")),
                _createElementVNode("span", _hoisted_7, _toDisplayString(ageAtDeath.value), 1),
                _cache[3] || (_cache[3] = _createTextVNode(". "))
              ]),
              _createElementVNode("p", _hoisted_8, [
                _cache[4] || (_cache[4] = _createTextVNode(" This means you need a plan which pays you an income for at least ")),
                _createElementVNode("span", _hoisted_9, _toDisplayString(lifeExpectancy.value), 1),
                _cache[5] || (_cache[5] = _createTextVNode(" years, if you retire when planned. "))
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(PageNav, {
      "back-link": "personaldetails",
      onNextClicked: onNextClicked,
      "parent-will-handle-next": true,
      "next-link": nextLink.value
    }, null, 8, ["next-link"])
  ]))
}
}

})